import React from "react";
import { Dialog, Tab, Tabs, KeyCombo, Classes
/*, Tooltip*/
} from "@blueprintjs/core"; // import { startCase } from "lodash";

import classNames from "classnames";
import { getHotkeyProps
/*, hotkeysById, comboToLabel*/
} from "../utils/hotkeyUtils";
import "./style.css";
export default function HotkeysDialog(props) {
  if (!props.hotkeySets) {
    console.error("Missing hotkeySets in HotkeysDialog");
    return null;
  }

  var sections = Object.keys(props.hotkeySets);
  return /*#__PURE__*/React.createElement(Dialog, {
    isOpen: props.isOpen,
    onClose: props.onClose,
    title: props.dialogTitle || "Keyboard Shortcuts"
  }, /*#__PURE__*/React.createElement(Tabs, {
    className: "tg-hotkeys-dialog"
  }, sections.map(function (name) {
    return /*#__PURE__*/React.createElement(Tab, {
      key: name,
      id: name,
      title: sections.length === 1 ? undefined : name,
      panel: /*#__PURE__*/React.createElement("div", {
        className: "tg-table-wrapper"
      }, /*#__PURE__*/React.createElement("table", {
        className: classNames(Classes.HTML_TABLE, Classes.HTML_TABLE_STRIPED, Classes.HTML_TABLE_BORDERED)
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Action"), /*#__PURE__*/React.createElement("th", null, "Shortcut"))), /*#__PURE__*/React.createElement("tbody", null, Object.keys(props.hotkeySets[name]).map(function (id) {
        var def = getHotkeyProps(props.hotkeySets[name][id], id);
        return /*#__PURE__*/React.createElement("tr", {
          key: id
        }, /*#__PURE__*/React.createElement("td", null, def.label), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(KeyCombo, {
          combo: def.combo
        })));
      }))))
    });
  })));
}